import gif from './loading.gif'
const LoadingPage = () => {
    return (
        <div className='container w-75 auto mt-5  border rounded'>
            <img className='d-block mx-auto mt-5' src={gif} alt='Loading...'></img>
            <h2 className='text-center mt-3 mb-3'>This may take a while, please wait...</h2>
        </div>
    )
}

export default LoadingPage;